import DependentFields from 'utils/DependentFields';

window.jQuery((event)=>{
  DependentFields.init();
});

window.jQuery(document).on('ajax:complete', ()=>{
  DependentFields.init();
});